import { render, staticRenderFns } from "./DossierEditAutoFillModal.vue?vue&type=template&id=49794e3e"
import script from "./DossierEditAutoFillModal.vue?vue&type=script&lang=ts"
export * from "./DossierEditAutoFillModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49794e3e')) {
      api.createRecord('49794e3e', component.options)
    } else {
      api.reload('49794e3e', component.options)
    }
    module.hot.accept("./DossierEditAutoFillModal.vue?vue&type=template&id=49794e3e", function () {
      api.rerender('49794e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/DossierEditAutoFillModal.vue"
export default component.exports